// Need to use tailwindcss to style this component

import { twMerge } from "tailwind-merge";

export type BadgeVariantType = "success" | "warning" | "disabled";
interface BadgeProps {
  variant?: BadgeVariantType;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

const BADGE_VARIANTS: { [K in BadgeVariantType]: string } = {
  success: "text-green-700 bg-green-50 border border-green-200",
  warning: "text-yellow-800 bg-yellow-50 border border-yellow-600",
  disabled: "text-light-gray bg-neutral-50 border border-neutral-100"
};
const SHARED_CLASS =
  "inline-block py-[2px] px-2 rounded-lg font-semibold text-xs leading-[18px] text-center";

export const Badge = ({
  children,
  variant = "success",
  className,
  ...props
}: BadgeProps) => {
  return (
    <span
      className={twMerge(SHARED_CLASS, BADGE_VARIANTS[variant], className)}
      {...props}
    >
      {children}
    </span>
  );
};

export default Badge;
